import { InjectionToken, Provider, Type } from '@angular/core';
import { DatiIdentificativiFormService } from '../../forms/dati-identificativi/dati-identificativi-form.service';
import { NormeSrlFormService } from '../../forms/amm-controllo/norme-srl/norme-srl-form.service';
import { NormeSpaOrdinarioFormService } from '../../forms/amm-controllo/norme-spa-ordinario/norme-spa-ordinario-form.service';
import { NormeSpaDualisticoFormService } from '../../forms/amm-controllo/norme-spa-dualistico/norme-spa-dualistico-form.service';
import { NormeSpaMonisticoFormService } from '../../forms/amm-controllo/norme-spa-monistico/norme-spa-monistico-form.service';
import { AltreNotLibriSocFormService } from '../../forms/altre-not-libri-soc/altre-not-libri-soc-form.service';
import { BaseSocialeFormService } from '../../forms/base-sociale/base-sociale-form.service';
import { ConclusioniFormService } from '../../forms/conclusioni/conclusioni-form.service';
import { ContribBiennaleFormService } from '../../forms/contrib-biennale/contrib-biennale-form.service';
import { ContribLegge5992FormService } from '../../forms/contrib-legge-59-92/contrib-legge-59-92-form.service';
import { DatiBilancioFormService } from '../../forms/dati-bilancio/dati-bilancio-form.service';
import { DatiBilancioBisFormService } from '../../forms/dati-bilancio-bis/dati-bilancio-bis-form.service';
import { NaturaMutualisticaFormService } from '../../forms/natura-mutualistica/natura-mutualistica-form.service';
import { ScopoSocialeFormService } from '../../forms/scopo-sociale/scopo-sociale-form.service';
import { SezIIAccertamentoFormService } from '../../forms/sez-II-accertamento/sez-ii-accertamento-form.service';
import { BaseRevisioneFormService } from '../../abstracts/base-revisione-form.service';
import { SchedaCoopTrasportoFormService } from '../../forms/scheda-settore/scheda-coop-trasporto/scheda-coop-trasporto-form.service';
import { SchedaCoopSocialiFormService } from '../../forms/scheda-settore/scheda-coop-sociali/scheda-coop-sociali-form.service';
import { SchedaCoopProdLavoroFormService } from '../../forms/scheda-settore/scheda-coop-prod-lavoro/scheda-coop-prod-lavoro-form.service';
import { SchedaCoopPescaFormService } from '../../forms/scheda-settore/scheda-coop-pesca/scheda-coop-pesca-form.service';
import { SchedaCoopGaranziaFidiFormService } from '../../forms/scheda-settore/scheda-coop-garanzia-fidi/scheda-coop-garanzia-fidi-form.service';
import { SchedaCoopEdilizieFormService } from '../../forms/scheda-settore/scheda-coop-edilizie/scheda-coop-edilizie-form.service';
import { SchedaCoopDettagliantiFormService } from '../../forms/scheda-settore/scheda-coop-dettaglianti/scheda-coop-dettaglianti-form.service';
import { SchedaCoopConsumoFormService } from '../../forms/scheda-settore/scheda-coop-consumo/scheda-coop-consumo-form.service';
import { SchedaCoopAltreCoopFormService } from '../../forms/scheda-settore/scheda-coop-altre-coop/scheda-coop-altre-coop-form.service';
import { SchedaCoopAgricoleFormService } from '../../forms/scheda-settore/scheda-coop-agricole/scheda-coop-agricole-form.service';

export const REVISIONE_FORM_SERVICES = new InjectionToken<BaseRevisioneFormService[]>('REVISIONE_FORM_SERVICE');

const FORM_SERVICE_CLASSES: Type<BaseRevisioneFormService>[] = [
    DatiIdentificativiFormService,
    NormeSrlFormService,
    NormeSpaOrdinarioFormService,
    NormeSpaDualisticoFormService,
    NormeSpaMonisticoFormService,
    AltreNotLibriSocFormService,
    BaseSocialeFormService,
    ConclusioniFormService,
    ContribBiennaleFormService,
    ContribLegge5992FormService,
    DatiBilancioFormService,
    DatiBilancioBisFormService,
    NaturaMutualisticaFormService,
    ScopoSocialeFormService,
    SezIIAccertamentoFormService,
];

const SCHEDA_SETTORE_FORM_SERVICE_CLASSES: Type<BaseRevisioneFormService>[] = [
    SchedaCoopTrasportoFormService,
    SchedaCoopSocialiFormService,
    SchedaCoopProdLavoroFormService,
    SchedaCoopPescaFormService,
    SchedaCoopGaranziaFidiFormService,
    SchedaCoopEdilizieFormService,
    SchedaCoopDettagliantiFormService,
    SchedaCoopConsumoFormService,
    SchedaCoopAltreCoopFormService,
    SchedaCoopAgricoleFormService,
];

export const REVISIONE53_FORM_SERVICE_PROVIDERS: Provider[] = [
    ...FORM_SERVICE_CLASSES,
    ...FORM_SERVICE_CLASSES.map((service) => ({
        provide: REVISIONE_FORM_SERVICES,
        useExisting: service,
        multi: true,
    })),
    ...SCHEDA_SETTORE_FORM_SERVICE_CLASSES,
    ...SCHEDA_SETTORE_FORM_SERVICE_CLASSES.map((service) => ({
        provide: REVISIONE_FORM_SERVICES,
        useExisting: service,
        multi: true,
    })),
];
